import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, logFunnel } from "@/lib/analytics";

/**
 * Tracks SPA route changes as GA4 page_view events.
 * Placed inside <BrowserRouter> so useLocation() works.
 * gtag itself only fires the event if analytics_storage consent = granted.
 */
export const PageviewTracker = () => {
  const location = useLocation();
  useEffect(() => { logFunnel("visit"); }, []);
  useEffect(() => {
    trackPageview(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
  return null;
};
